import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from 'react-router-dom';

import Logout from '../../organisms/Logout';
import Home from '../Home';
import PayCompany from '../PayCompany';
import ExperimentsList from '../ExperimentsList';
import HeaderLeft from '../../organisms/HeaderLeft';

import Styled from './styles';
import UsageDashboard from '../UsageDashboard';
import NotificationDashboard from '../NotificationDashboard';
import CustomerSuccess from '../CustomerSuccess';
import SalesUtility from '../SalesUtility';
import salesJetpack from '../SalesJetpack';
import SecureLeads from '../SecureLeads';

class Authenticated extends Component {
  render() {
    return (
      <Styled.Container>
        <Router>
          <div>
            <Switch>
              <Redirect exact from="/" to="/pay" />

              <Route exact path="/" component={Home} />
              {/*<Route path="/company-meta/:companyId?" component={CompanyMeta} />*/}
              <Route path="/pay/:companyId?" component={PayCompany} />
              {/*<Route path="/paid-companies" component={PaidCompanyList} />*/}
              <Route path="/experiments" component={ExperimentsList} />
              <Route path="/salesJetpack" component={salesJetpack} />
              <Route path="/salesUtility" component={SalesUtility} />

              <Route path="/usage/:companyId" component={UsageDashboard} />

              <Route path="/notification" component={NotificationDashboard} />

              <Route path="/cs/:companyId" component={CustomerSuccess} />

              <Route path="/lead/:uuid" component={SecureLeads} />

              <Route component={Home} />
            </Switch>

            <Route component={HeaderLeft} />
          </div>
        </Router>

        <Styled.LogoutContainer>
          <Logout />
        </Styled.LogoutContainer>
      </Styled.Container>
    );
  }
}

export default Authenticated;



// WEBPACK FOOTER //
// ./src/pages/Authenticated/index.js